import TriggerLogIn from "./trigger_loggin";
import TriggerLogOut from "./trigger_logout";
import TriggerRelogin from "./trigger_relogin";

//
//component
//redux
//selector
//actions
const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------

  // -------------------------- USE EFFECT ---------------------

  // -------------------------- RETURN --------------------------
  return (
    <>
      {/* trigger auth */}
      <TriggerLogIn />
      <TriggerLogOut />
      <TriggerRelogin />
    </>
  );
};
export default TriggerInit;
